import { ProductRightSideHead } from './product-right-side-head';

export default ProductRightSideHead;
